<div class="grid grid-cols-1 gap-4">
  @for (group of groups; track trackByUuid($index, group)) {
    <em-product-group-card
      class="filter-set filter-set-{{ group.uuid }}"
      [group]="group"
      [allowDelete]="allowDelete"
      [compactView]="compactView"
      [showTags]="true"
    >
    </em-product-group-card>
  }
  @if (!groups?.length) {
    <div class="m-auto mt-10">{{ 'SHARED_MESSAGE_NO_ITEMS' | translate }}</div>
  }
</div>
